const request = require('browser-request')
const queryString = require('query-string')

class WidgetSDK {

  constructor (GatewayConfig) {
    this.url = GatewayConfig.url
    this.url23 = GatewayConfig.url23
  }

  get (route, params, callback, version) {
    let qs = ''
    if (Object.values(params).length > 0) {
      qs = '?' + queryString.stringify(params)
    }
    let v = ''
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    request.get({
      url: this.url + v + route + qs,
      json: true,
      body: params
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }

  post (route, params, callback, version) {
    let v = ''
    if (version || (typeof version !== 'undefined' && version.length === 0)) {
      v = version + ''
    }
    request.post({
      url: this.url + v + route,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      callback(body)
    })
  }

  post23 (vue, route, params, callback) {
    let self = this
    request.post({
      url: self.url23 + route,
      json: true,
      body: JSON.stringify(params)
    }, function (err, res, body) {
      if (err) throw err
      if (body.error) {
        try {
          if (body.error.message.endsWith('.')) body.error.message = body.error.message.slice(0, -1)
          body.error.message = vue.$t('backend.' + body.error.message)
        } catch (err) {
          body.error.message = body.error.message
        }
      }
      callback(body)
    })
  }

}

export default WidgetSDK



// WEBPACK FOOTER //
// ./src/modules/sdk.js